import api from './setAxios';
import React, { useState } from "react";

const CreateComment = ({ blogId, parentId = 0, onCommentSubmitted }) => { 
    const [isCorrect, setIsCorrect] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [num1, setNum1] = useState(Math.floor(Math.random() * 10));
    const [num2, setNum2] = useState(Math.floor(Math.random() * 10));
    const [userAnswer, setUserAnswer] = useState("");
    const [author, setAuthor] = useState(""); 
    const [phone, setPhone] = useState(""); 
    const [comment, setComment] = useState(""); 
    const [errorMessage, setErrorMessage] = useState("");

    const handleAnswerChange = (e) => {
        setUserAnswer(e.target.value);
    };

    const refreshQuestion = () => {
        setNum1(Math.floor(Math.random() * 10));
        setNum2(Math.floor(Math.random() * 10));
        setUserAnswer("");
        setErrorMessage("");
        setIsCorrect(null);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setIsSubmitting(true); 
        const correctAnswer = num1 * num2; 

        if (parseInt(userAnswer, 10) !== correctAnswer) {
            setErrorMessage("پاسخ کد امنیتی اشتباه است.");
            setIsSubmitting(false);
            return;
        }
    
        setErrorMessage(""); 
        try {
            const response = await api.post("Comment/SubmitComment", {
                BlogID: blogId,
                ParentID: parentId,
                Name: author,
                Phone:phone,
                Note: comment,
                commentUrl: window.location.href
            });
            setErrorMessage("دیدگاه شما ثبت شد!");
            if (onCommentSubmitted) {
                onCommentSubmitted();
            }
        } catch (error) {
            console.error("خطا در ارسال دیدگاه:", error.response?.data || error.message);
            setErrorMessage("مشکلی در ارسال دیدگاه رخ داده است.");
        }
        finally {
            setIsSubmitting(false); 
        }
    };


    return (
        <form className='frm-comment' onSubmit={handleSubmit} >
            <div className='comment-fields'>
                <input
                    type="text"
                    name="author"
                    className="form-control comment-textbox"
                    placeholder="نام"
                    value={author}
                    onChange={(e) => setAuthor(e.target.value)}
                />&nbsp;&nbsp;
                <div className='comment-div-text' >
                    <input
                        type="number"
                        name="phone"
                        className="form-control comment-textbox"
                        placeholder="شماره همراه "
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        required
                    />
                    <p className='comment-p-text' >
                        در صورت تمایل شماره خود را وارد کنید تا بعد از پاسخ از طریق پیامک به شما اطلاع دهیم. (این شماره به دیگران نمایش داده نمی‌شود)
                    </p>
                </div>
            </div>
            <textarea
                className="comment-message"
                name="comment"
                placeholder="پاسخ"
                aria-required="true"
                cols="45" 
                rows="8"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                required
            />
            <div className='submit-comment'>
                <span className="error-message" >{errorMessage}</span>
                <label className="reply-security-label">
                    {num1} × {num2} =
                </label>
                <input type="text"
                    placeholder="پاسخ"
                    className="reply-security-reply"
                    onChange={handleAnswerChange}
                    required
                />
                <button onClick={refreshQuestion} className="replay-answer">
                &#x21bb;
                </button>
                <input name="submit" type="submit" id="submit-comment" className="btn save_comment " value="ارسال دیدگاه" />
            </div> 
        </form>
    );
};

export default CreateComment;
